import React, { Component } from "react";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";
import SweetAlert from "react-bootstrap-sweetalert";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      remember: false,
      randomNumber: 0,
      loading: false,
      alertText: "",
      loginAlert: false,
    };
  }

  login = () => {
    this.setState({ loading: true });
    const postData = {
      Username: this.state.username,
      Password: this.state.password,
      //"IsRememberMeChecked": false
    };

    axios
      .post("/api/v1/users/login", postData)

      .then((res) => {
        if (res.status === 200 && res.data.statusCode === 200) {
          if (res.data.data !== null) {
            this.setJWT(res.data.data.accessToken);
            axios.defaults.headers.common["Authorization"] =
              res.data.data.accessToken;
            const r = res.data.data;
            const member = {
              fullName: r.fullName ?? r.FullName ?? "",
              userName: r.userName ?? r.UserName ?? "",
              phoneNumber: r.phoneNumber ?? r.PhoneNumber ?? "",
              role: r.role ?? r.Role ?? "",
              type: r.type ?? r.Type ?? "",
              clientId: r.clientId ?? r.ClientId ?? null,
            };
            localStorage.setItem("member", JSON.stringify(member));
            localStorage.setItem("loggedIn", true);
            this.setState({ member: member, loading: false });
            window.location.href = "/";
          } else
            this.setState({
              alertText: res.data.errors,
              loginAlert: true,
              loading: false,
            });
        } else
          this.setState({
            alertText: res.data.errors,
            loginAlert: true,
            loading: false,
          });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          this.setState({
            alertText: error.response.data.message,
            loginAlert: true,
          });
        } else {
          this.setState({
            alertText: "اتصالی با سرور ایجاد نشد!",
            loginAlert: true,
          });
        }
      });
  };
  setJWT = (jwt) => {
    jwt === ""
      ? console.log("No jwt was received")
      : localStorage.setItem("jwt", jwt);
  };
  getCurrentMember = (jwt) => {
    axios.defaults.headers.common["Authorization"] = jwt;
    axios
      .post("/api/v1/users/me")
      .then((res) => {
        if (res.status === 200 && res.data.statusCode === 200) {
          localStorage.setItem("member", JSON.stringify(res.data.data));
          localStorage.setItem("loggedIn", true);
          this.setState({ member: res.data.data, loading: false });
          window.location.href = "/";
          //console.log(res.data.data)
        } else {
          this.setState({
            loading: false,
            alertText: "Authorization failed!",
            loginAlert: true,
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (error.response) {
          this.setState({
            alertText: error.response.data.message,
            loginAlert: true,
          });
        } else {
          this.setState({
            alertText: "اتصالی با سرور ایجاد نشد!",
            loginAlert: true,
          });
        }
      });
  };

  onUserLogin = (values) => {
    if (!this.state.loading) {
      if (values.username !== "" && values.password !== "") {
        this.setState(
          { username: values.username, password: values.password },
          () => {
            this.login();
          },
        );
      }
    }
  };
  validateUsername = (value) => {
    let error;
    if (!value) {
      error = "لطفا نام کاربری را وارد کنید";
    }
    return error;
  };
  validatePassword = (value) => {
    let error;
    if (!value) {
      error = "لطفا رمز عبور را وارد کنید";
    }
    return error;
  };

  openAlert(key) {
    this.setState({ [key]: true });
  }

  closeAlert(key) {
    this.setState({ [key]: false });
  }

  render() {
    const { password, username, loading, alertText, loginAlert } = this.state;
    const initialValues = { username, password };

    return (
      <Row className="justify-content-center align-items-center d-flex mt-5">
        <Colxx xxs="12" md="5">
          <Card className="auth-card">
            <div className="form-side justify-content-center align-items-center d-flex flex-column">
              <div className="logo-single mb-2" />
              <CardTitle className="mb-5">
                سامانه اعلام بار نیمروز بار
              </CardTitle>

              <Formik initialValues={initialValues} onSubmit={this.onUserLogin}>
                {({ errors, touched }) => (
                  <Form className="av-tooltip tooltip-label-bottom w-md-75 w-100">
                    <FormGroup className="form-group has-float-label">
                      <Label>نام کاربری</Label>
                      <Field
                        className="form-control"
                        name="username"
                        validate={this.validateUsername}
                      />
                      {errors.username && touched.username && (
                        <div className="invalid-feedback d-block">
                          {errors.username}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group has-float-label">
                      <Label>رمز عبور</Label>
                      <Field
                        className="form-control"
                        type="password"
                        name="password"
                        validate={this.validatePassword}
                      />
                      {errors.password && touched.password && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>

                    <div className="d-flex flex-column justify-content-center">
                      <Button
                        color="primary"
                        className={`btn-shadow btn-multiple-state mt-4 ${loading ? "show-spinner" : "text-center"}`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">ورود</span>
                      </Button>
                      {/* <NavLink
                        to={`/newregister`}
                        className="mt-4 text-center opacity-50"
                      >
                        ثبت نام شركت حمل و نقل
                      </NavLink> */}
                      <NavLink
                        to={`/newregisterproductowner`}
                        className="mt-4 text-center opacity-50"
                      >
                        ثبت نام صاحب کالا
                      </NavLink>
                      <NavLink
                        to={`/user/forgot-password`}
                        className="mt-4 text-center opacity-50"
                      >
                        رمز عبور را فراموش کرده‌ام
                      </NavLink>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </Colxx>

        <SweetAlert
          focusConfirmBtn={false}
          error
          confirmBtnText="متوجه شدم"
          confirmBtnStyle={{ width: "87px" }}
          confirmBtnBsStyle="danger"
          btnSize="sm"
          show={loginAlert}
          title={"خطای ورود"}
          onConfirm={() => this.closeAlert("loginAlert")}
          onClickOutside={() => this.closeAlert("loginAlert")}
          onCancel={() => this.closeAlert("loginAlert")}
        >
          {alertText}
        </SweetAlert>
      </Row>
    );
  }
}

export default Login;
